<template>
    <a id="btn-logout"
       class="btn-main-func"
       href="#"
       :title="i18n.t('tooltip_logout')"
       @click.prevent="signOff"
    >
        <img src="~images/btn_logout.png">
    </a>
</template>

<script>

    import {ref, reactive, onMounted, watchEffect, computed, watch, inject}  from "vue"
    import {logout, forceLogout} from "@/modules/api/auth";
    import router from "@/router"

    export default {
        setup(props, context) {

            const i18n = inject('i18n');

            const signOff = async () => {
                await logout();
                router.push({path:"login", query:{loggedOut:1}});
            }

            return {
                i18n,
                signOff
            }
        }
    }
</script>

<style scoped lang="scss">


</style>